var map = {
	"./Arabic.png": 98,
	"./English.png": 99,
	"./Login.png": 97,
	"./action_shap.png": 418,
	"./author_img.png": 419,
	"./banner_bg.png": 179,
	"./banner_img.png": 180,
	"./divider.png": 181,
	"./dot.png": 182,
	"./icon01.png": 420,
	"./icon02.png": 421,
	"./icon3.png": 422,
	"./icon_04.png": 423,
	"./icon_05.png": 424,
	"./icon_shape1.png": 425,
	"./icon_shape2.png": 426,
	"./icon_shape3.png": 427,
	"./icon_shape4.png": 428,
	"./process_1.png": 429,
	"./process_2.png": 430,
	"./process_3.png": 431,
	"./process_4.png": 432,
	"./process_5.png": 433,
	"./shape.png": 434,
	"./team1.jpg": 64,
	"./team2.jpg": 40,
	"./work1.png": 435,
	"./work2.png": 436,
	"./work3.png": 437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 244;